import { SCOPE_META } from "@/lib/constants";

// Owner badge: 🌐 Platform · 🏫 Gym · 👤 Personal
export const ScopeBadge = ({ scope, className = "" }) => {
  const m = SCOPE_META[scope] || SCOPE_META.personal;
  return (
    <span data-testid={`scope-badge-${scope || "personal"}`}
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider px-2 py-0.5 rounded ${className}`}>
      <span aria-hidden="true">{m.emoji}</span>{m.label}
    </span>
  );
};
